import * as yup from 'yup';
import { checkDateIsStrictlyLower, createUTCDateFromDateString } from 'utils/date';

const checkEndDateUnchanged = (value: Date | undefined, context: yup.TestContext): boolean => {
  if (value === undefined) {
    return false;
  } else {
    return value.getTime() === context.parent.initialEndDate.getTime();
  }
};

const sortingCenterContractsEditFormSchema = (pt: any, closureDate: Date): yup.AnyObjectSchema => {
  const SortingCenterContractSchema = yup.object().shape({
    characterizationNumber: yup
      .number()
      .required(pt('validation.characterizationNumber.required'))
      .positive(pt('validation.characterizationNumber.required'))
      .integer(pt('validation.characterizationNumber.integer')),
    endDate: yup
      .date()
      .typeError(pt('validation.endDate.type')) // Message d'erreur pour un format non valide
      .required(pt('validation.endDate.required'))
      .test('endDateValidation', pt('validation.endDate.lesserThanStartDate'), function (value) {
        if (checkEndDateUnchanged(value, this)) return true;
        const startDate = this.parent.startDate;
        return checkDateIsStrictlyLower(startDate, value);
      })
      .test('alreadyClosedMonthFinalDate', pt('validation.endDate.alreadyClosedMonth'), function (value) {
        if (checkEndDateUnchanged(value, this)) return true;
        return checkDateIsStrictlyLower(closureDate, value);
      })
      .test(
        'lesserThanReceptionOrCharacterization',
        pt('validation.endDate.lesserThanReceptionOrCharacterization'),
        function (value) {
          if (checkEndDateUnchanged(value, this)) return true;
          if (this.parent.limitDate) {
            return checkDateIsStrictlyLower(createUTCDateFromDateString(this.parent.limitDate), value);
          }
          return true;
        },
      ),
  });

  return yup.object().shape({
    activeContracts: yup.array().of(SortingCenterContractSchema).required(),
  });
};

export { sortingCenterContractsEditFormSchema };
